import _ from 'lodash';

export const NavigationMenuItemTestIds = {
  getTabId: title => `header-nav.${_.kebabCase(title)}-tab`,
};
